import React, { useContext, useEffect } from "react";
import HeaderComponent from "../../../components/header/header.component";
import { CasesProvider, GlobalContext } from "../../../store";
import { CommonService } from "../../../services/common/common.service";
import { useTranslation } from "react-i18next";
import ComingSoonComponent from "../../../components/coming-soon/coming-soon.component";
import PagesHeadComponent from "../../../components/pages-head-component/pages-head.component";
import { icons } from "../../../statics/icons";
import { ContentLayout } from "../../../layouts/content/content.layout";

const AITrackingPage = () => {
  const { t } = useTranslation();
  const commonService: CommonService = new CommonService();
  const { setPageTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTimeout(() => {
      commonService.setTitle(t("PAGE_META_TITLES.AI_COMPLIANCE_TRACKING"));
      setPageTitle(t("PAGE_META_TITLES.AI_COMPLIANCE_TRACKING"));
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CasesProvider>
      <HeaderComponent />
      <ContentLayout>
        <PagesHeadComponent
          title={t("PAGES_HEAD.AI_TRACKING_TITLE")}
          subTitle={t("PAGES_HEAD.AI_TRACKING_SUB_TITLE")}
          logo={icons.PAGES.HEAD.AI_TRACKING}
        />
        <ComingSoonComponent />
      </ContentLayout>
    </CasesProvider>
  );
};

export default AITrackingPage;
